var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "login__form",
      attrs: { novalidate: "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          _vm.valid() ? _vm.checkIfUserHasBeenMigrated() : null
        }
      }
    },
    [
      _c(
        "sc-field",
        [
          _c("sc-input", {
            ref: "email",
            attrs: {
              type: "email",
              name: "email",
              placeholder: "Informe seu e-mail",
              disabled: _vm.loading,
              required: ""
            },
            on: {
              blur: function($event) {
                _vm.$emit("update:email", _vm.form.email)
              }
            },
            model: {
              value: _vm.form.email,
              callback: function($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "sc-field",
        [
          _c("sc-button", {
            staticClass: "is-fullwidth",
            attrs: {
              type: "submit",
              theme: "primary",
              text: "Próximo",
              loading: _vm.loading
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ab7e28e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab7e28e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/features/public/login/default/forms/FormEmail.vue
// module id = null
// module chunks = 